"use client";

import Link from "next/link";
import { ComponentProps, useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { logEvent } from "@/service/logs/log";

export function HomeCardLink({
  card,
  ...props
}: { card: string } & ComponentProps<typeof Link>) {
  const { logView } = useContext(ResourceContext);

  return (
    <Link
      {...props}
      onClick={() => logEvent("club_home_card_click", logView, { card })}
    />
  );
}
